import React from 'react';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentFailedImage from '../../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';

interface AnulledFinalStateProps {
  procedure: any;
}

const AnulledFinalState = (props: AnulledFinalStateProps) => {
  const { procedure } = props;
  return (
    <>
      {procedure?.steps[2]?.date && (
        <div style={{ paddingBottom: '8px' }}>{procedure?.steps[2]?.date}</div>
      )}
      <CardProgress
        image={[documentFailedImage, documentFailedDskImage]}
        title={`Tu solicitud se ha anulado`}
        subtitle="No pagaste a tiempo el monto de tu trámite."
      />
    </>
  );
};

export default AnulledFinalState;
